import { injectIntl } from "react-intl";
import { intlShape } from "lcm-iot-commons";

type OwnProps = {
  intl: intlShape;
  redirectUri?: string;
};

const defaultProps: Partial<OwnProps> = {
  redirectUri: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function PasswordResetSuccess({ intl, redirectUri }: Props) {
  return (
    <div className="row">
      <div className="col-sm-6">
        <h1>{intl.formatMessage({ id: "password_reset.success.header" })}</h1>
        <p>
          {intl.formatMessage({ id: "password_reset.success.description" })}
        </p>
        <a
          id="sign-in"
          data-turbolinks="false"
          href={redirectUri}
          className="btn btn-primary space-before"
          role="button"
        >
          {intl.formatMessage({ id: "password_reset.success.signin" })}
        </a>
      </div>
    </div>
  );
}

PasswordResetSuccess.defaultProps = defaultProps;

export default injectIntl(PasswordResetSuccess);
